document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".gallery-top").forEach((item) => {
    const sliderThumbs = new Swiper(item.nextElementSibling.firstElementChild, {
      direction: "horizontal",
      slidesPerView: 5,
      spaceBetween: 8,
      mousewheel: true,
      freeMode: true,
    })
    const sliderImages = new Swiper(item, {
      direction: "horizontal",
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1000,
      mousewheel: false,
      grabCursor: false,
      allowTouchMove: false,
      thumbs: {
        swiper: sliderThumbs,
      },
      navigation: {
        nextEl: item.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild,
        prevEl: item.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild.nextElementSibling,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      pagination: {
        el: item.querySelector(".swiper-pagination"),
        clickable: true,
        type: "progressbar",
      },
      // scrollbar: {
      //   el: item.firstElementChild.nextElementSibling,
      // },
      breakpoints: {
        0: {
          direction: "horizontal",
          mousewheel: false,
          allowTouchMove: true,
        },
        750: {
          direction: "horizontal",
          allowTouchMove: false,
        },
      },
    })
  })

  // const waitForHiddenInput = setInterval(() => {
  //   const hiddenPlanInput = document.querySelector('input[name="selling_plan"]')
  //   const sealElement = document.querySelector(".sealsubs-target-element")

  //   if (hiddenPlanInput) {
  //     console.log("sealElement", sealElement)

  //     clearInterval(waitForHiddenInput)

  //     const updatePriceFromPlan = () => {
  //       const planId = hiddenPlanInput.value
  //       console.log("planId", planId)

  //       if (!planId) return

  //       const planIdNumber = parseInt(planId, 10)

  //       if (sealElement) {
  //         const productDataRaw = sealElement.getAttribute("data-product")

  //         if (productDataRaw) {
  //           const productData = JSON.parse(productDataRaw)
  //           console.log("Product ID:", productData.id)
  //           console.log("Title:", productData.title)
  //           console.log("Variants:", productData.variants)

  //           for (const variant of productData.variants) {
  //             const allocations = variant.selling_plan_allocations || []

  //             for (const allocation of allocations) {
  //               if (allocation.selling_plan_id === planIdNumber) {
  //                 const price = allocation.price
  //                 const compareAtPrice = allocation.compare_at_price

  //                 console.log("✅ Совпадение найдено:")
  //                 console.log("Цена:", price)
  //                 console.log("Compare at Price:", compareAtPrice)

  //                 // Обновляем цену в DOM
  //                 const priceElement = document.querySelector(".price__number .money")
  //                 if (priceElement && compareAtPrice) {
  //                   priceElement.textContent = `$${(price / 100).toFixed(2)}`
  //                 }

  //                 return // нашли нужный план, выходим
  //               }
  //             }
  //           }

  //           console.log("❌ Подходящий selling_plan_id не найден")
  //         }
  //       }
  //     }

  //     // Следим за изменением value у input
  //     const observer = new MutationObserver(updatePriceFromPlan)
  //     observer.observe(hiddenPlanInput, {
  //       attributes: true,
  //       attributeFilter: ["value"],
  //     })

  //     // Обновим цену при первой инициализации
  //     updatePriceFromPlan()
  //   }
  // }, 300)
})
